import { render } from "./complete-slider-hero.vue?vue&type=template&id=7097fb70"
import script from "./complete-slider-hero.vue?vue&type=script&lang=js"
export * from "./complete-slider-hero.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__